module.exports = __webpack_public_path__ + "static/media/38.380bf1c7.png";